import { motion } from "framer-motion";
import { LuShieldCheck, LuBot, LuChartLine } from "react-icons/lu";
import type { IconType } from "react-icons";
import { useLang } from "../i18n";
import { valuesContent } from "../data/content";
import "./Values.css";

/**
 * "Vad vi gör" — 3 värde-kort. Ikonerna matchas mot `iconKey` från datan
 * så typad översättning och presentation kan utvecklas oberoende.
 */
const ICONS: Record<"shield" | "bot" | "insights", IconType> = {
  shield: LuShieldCheck,
  bot: LuBot,
  insights: LuChartLine,
};

export default function Values() {
  const { t } = useLang();

  return (
    <section id="values" className="values">
      <div className="container">
        <motion.header
          className="values-header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.5 }}
        >
          <span className="section-eyebrow">{t(valuesContent.eyebrow)}</span>
          <h2 className="section-heading">{t(valuesContent.title)}</h2>
        </motion.header>

        <div className="values-grid">
          {valuesContent.cards.map((c, idx) => {
            const Icon = ICONS[c.iconKey];
            return (
              <motion.article
                key={c.iconKey}
                className="value-card"
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.55, delay: idx * 0.1 }}
              >
                <div className="value-card-icon" aria-hidden>
                  <Icon size={24} />
                </div>
                <h3>{t(c.title)}</h3>
                <p>{t(c.body)}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
